<template>
  <b-alert
    show
    class="tw-py-3 lg:tw-px-7 tw-font-medium tw-bg-[#ECE8F5] tw-border-none tw-mb-0 tw-flex tw-justify-center tw-items-center"
  >
    <div>
      <span class="tw-text-md lg:tw-text-xl tw-align-middle tw-font-bold">
        Get 20% off your first hair, skin, or sexual wellness <a
          href="javascript:;"
          class="tw-underline"
          @click="$emit('open-upsell')"
        > treatment</a>!
      </span>
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'PortalCampaignBanner',
}
</script>